export default function ProductCarriers() {
  return [
    {
      carrierName: "",
      displayOrder: 1,
      logoLink: "https://nbapplicationdata.blob.core.windows.net/public/Consumer/logos/Carriers/corebridge.png",
    },
    {
      carrierName: "",
      displayOrder: 2,
      logoLink: "https://nbapplicationdata.blob.core.windows.net/public/Consumer/logos/Carriers/mass-mutual.png",
    },
    {
      carrierName: "",
      displayOrder: 3,
      logoLink: "https://nbapplicationdata.blob.core.windows.net/public/Consumer/logos/Carriers/mutual-of-omaha.png",
    },
    {
      carrierName: "",
      displayOrder: 4,
      logoLink: "https://nbapplicationdata.blob.core.windows.net/public/Consumer/logos/Carriers/nationwide.png",
    },
    
    {
      carrierName: "",
      displayOrder: 5,
      logoLink: "https://nbapplicationdata.blob.core.windows.net/public/Consumer/logos/Carriers/sbli.png",
    },
    {
      carrierName: "",
      displayOrder: 6,
      logoLink: "https://nbapplicationdata.blob.core.windows.net/public/Consumer/logos/Carriers/securian.png",
    },
    {
      carrierName: "",
      displayOrder: 7,
      logoLink: "https://nbapplicationdata.blob.core.windows.net/public/Consumer/logos/Carriers/transamerica.png",
    },
  ]
}


// WEBPACK FOOTER //
// ./src/components/Helpers/Data/Products/WholeLife/ProductCarriers.js